import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { share } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class UnidadService {
    private idHabitacionSource = new BehaviorSubject<any>([]);
    public idHabitacion$ = this.idHabitacionSource.asObservable();

    private idGastronomiaSource = new BehaviorSubject<any>([]);
    public idGastronomia$ = this.idGastronomiaSource.asObservable();

    private idSalonSource = new BehaviorSubject<any>([]);
    public idSalon$ = this.idSalonSource.asObservable();
    private ObservableBanner:Observable<any>[]=[]

    constructor(
        private http: HttpClient,
    ) { }

    validaTipoVideo(linkVideo) {
        const urlVideo = linkVideo;
        let linkVideoAux: any;
        if (linkVideo !== undefined) {
            if (linkVideo.indexOf('watch?v=') > -1) {
                linkVideoAux = urlVideo.replace('watch?v=', 'embed/');
            }
        }
        return linkVideoAux;
    }

    getListaUnidades() {
        console.log(`${environment.api_baseurl_ecc_socios}/api/unidades`);
        return this.http.get(`${environment.api_baseurl_ecc_socios}/api/unidades`);
    }

    getUnidad(pIdUnidad: any) {
        console.log(`${environment.api_baseurl_ecc_socios}/api/unidades/` + pIdUnidad);
        return this.http.get(`${environment.api_baseurl_ecc_socios}/api/unidades/${pIdUnidad}`);
    }

    getListaUnidadesCercanas(latitud: any, longitud: any) {
        if (latitud != null && longitud != null) {
            console.log(`${environment.api_baseurl_ecc_socios}/api/unidades/latitud=` + latitud + `&longitud=` + longitud);
            return this.http.get(`${environment.api_baseurl_ecc_socios}/api/unidades/latitud=${latitud}&longitud=${longitud}`);
        } else {
            return this.getListaUnidades();
        }
    }

    serviciosUnidad(idUnidad, idIdioma) {
        // tslint:disable-next-line: max-line-length
        return this.http.get(`${environment.path}${environment.service.serviciosUnidad.endpoint}?idUnidad=${idUnidad}&idIdioma=${idIdioma}`);
    }

    serviciosUnidadData(idUnidad: number, idIdioma: number) {
        // tslint:disable-next-line: max-line-length
        return this.http.get(`${environment.path}${environment.service.serviciosUnidadData.endpoint}?idUnidad=${idUnidad}&idIdioma=${idIdioma}`);
    }

    headerUnidad(idUnidad, idIdioma) {
        return this.http.get(`${environment.path}${environment.service.headerUnidad.endpoint}?idUnidad=${idUnidad}&idIdioma=${idIdioma}`);
    }

    promocionesDestacadasUnidad(idUnidad, idIdioma) {
        // tslint:disable-next-line: max-line-length
        return this.http.get(`${environment.path}${environment.service.promocionesDestacadasUnidad.endpoint}?idUnidad=${idUnidad}&idIdioma=${idIdioma}`);
    }

    espectaculosDestacadosUnidad(idUnidad, idIdioma) {
        // tslint:disable-next-line: max-line-length
        return this.http.get(`${environment.path}${environment.service.espectaculosDestacadosUnidad.endpoint}?idUnidad=${idUnidad}&idIdioma=${idIdioma}`);
    }

    itemCalendario(idUnidad, idIdioma, fechaDesde, fechaHasta) {
        // tslint:disable-next-line: max-line-length
        return this.http.get(`${environment.path}${environment.service.itemCalendario.endpoint}?idUnidad=${idUnidad}&idIdioma=${idIdioma}&fechaDesde=${fechaDesde}&fechaHasta=${fechaHasta}`);
    }

    itemCalendarioActividades(idUnidad, idIdioma, fechaDesde, fechaHasta) {
        // tslint:disable-next-line: max-line-length
        return this.http.get(`${environment.path}/crm.secciones/api/cms/Secciones/Seccion/GetUnidadEspectaculosCalendario?idUnidad=${idUnidad}&idIdioma=${idIdioma}&fechaDesde=${fechaDesde}&fechaHasta=${fechaHasta}`);
        //return this.http.get(`${environment.path}${environment.service.itemCalendario.endpoint}?idUnidad=${idUnidad}&idIdioma=${idIdioma}&fechaDesde=${fechaDesde}&fechaHasta=${fechaHasta}`);
    }

    contenidoCasinoUnidad(idUnidad, idIdioma) {
        // tslint:disable-next-line: max-line-length
        return this.http.get(`${environment.path}${environment.service.contenidoCasinoUnidad.endpoint}?idUnidad=${idUnidad}&idIdioma=${idIdioma}`);
    }

    contenidoBannerUnidad(idUnidad: number, idIdioma: number) {
        // tslint:disable-next-line: max-line-length
        if(this.ObservableBanner[idUnidad]==null){
            this.ObservableBanner[idUnidad] =  this.http.post(`${environment.path}/crm.unidad/api/cms/Banners/GetBanners`, { "IdUnidad": idUnidad }).pipe(share());
        }
        return  this.ObservableBanner[idUnidad];
        //return this.http.get(`${environment.path}${environment.service.contenidoBannerUnidad.endpoint}?idUnidad=${idUnidad}&idIdioma=${idIdioma}`);
    }

    contenidoHotelUnidad(idUnidad: number, idIdioma?: number) {
        // tslint:disable-next-line: max-line-length
        return new Promise((resolve, reject) => {
            this.http.get(`${environment.path}${environment.service.contenidoHotelUnidad.endpoint}?idUnidad=${idUnidad}&idIdioma=${idIdioma}`).subscribe( data => {
                resolve(data)
            })
        })
    }

    detalleHabitacion(idHabitacion: number, idIdioma: number) {
        // tslint:disable-next-line: max-line-length
        return this.http.get(`${environment.path}${environment.service.contenidoDetalleHabitacion.endpoint}?idHabitacion=${idHabitacion}&idIdioma=${idIdioma}`);
    }
    setDataHabitacion(value) {
        this.idHabitacionSource.next(value);
    }
    setDataGastronomia(value) {
        this.idGastronomiaSource.next(value);
    }
    setDataSalon(value) {
        this.idSalonSource.next(value);
    }
    contenidoDetalleJuegosCasinoUnidad(idUnidad: number, idJuego: number, idIdioma: number) {
        // tslint:disable-next-line: max-line-length
        return this.http.get(`${environment.path}${environment.service.contenidoDetalleJuego.endpoint}?idUnidad=${idUnidad}&idJuego=${idJuego}&idIdioma=${idIdioma}`);
    }

    contenidoSpaUnidad(idUnidad: number, idIdioma: number) {
        // tslint:disable-next-line: max-line-length
        return new Promise((resolve, reject) => {
            this.http.get(`${environment.path}${environment.service.contenidoSpaUnidad.endpoint}?idUnidad=${idUnidad}&idIdioma=${idIdioma}`).subscribe( data => {
                resolve(data)
            })
        })
    }

    contenidoDiscotequeUnidad(idUnidad: number, idIdioma: number) {
        // tslint:disable-next-line: max-line-length
        return this.http.get(`${environment.path}${environment.service.contenidoDiscotequeUnidad.endpoint}?idUnidad=${idUnidad}&idIdioma=${idIdioma}`);
    }

    contenidoDetalleRestaurant(idUnidad: number, idIdioma: number) {
        // tslint:disable-next-line: max-line-length
        return this.http.get(`${environment.path}${environment.service.contenidoDetalleRestaurant.endpoint}?idUnidad=${idUnidad}&idIdioma=${idIdioma}`);
    }

    contenidoGastronomiaUnidad(idUnidad: number, idIdioma: number) {
        // tslint:disable-next-line: max-line-length
        return new Promise((resolve, reject) => {
            this.http.get(`${environment.path}${environment.service.contenidoGastronomiaUnidad.endpoint}?idUnidad=${idUnidad}&idIdioma=${idIdioma}`).subscribe( data => {
                resolve(data)
            })
        })
    }

    contenidoEventosUnidad(idUnidad: number, idIdioma: number) {
        // tslint:disable-next-line: max-line-length
        return new Promise((resolve, reject) => {
            this.http.get(`${environment.path}${environment.service.contenidoEventosUnidad.endpoint}?idUnidad=${idUnidad}&idIdioma=${idIdioma}`).subscribe(data => {
                resolve(data);
            })
        })
    }

    contenidoCentroNegocios(idUnidad: number, idIdioma: number) {
        // tslint:disable-next-line: max-line-length
        return new Promise((resolve, reject) => {
            this.http.get(`${environment.path}${environment.service.contenidoNegocioUnidad.endpoint}?idUnidad=${idUnidad}&idIdioma=${idIdioma}`).subscribe( data => {
                resolve(data)
            })
        })
    }

    contenidoDetalleEventos(idUnidad: number, idIdioma: number) {
        // tslint:disable-next-line: max-line-length
        return this.http.get(`${environment.path}${environment.service.contenidoDetalleUnidad.endpoint}?idUnidad=${idUnidad}&idIdioma=${idIdioma}`);
    }


    promocionesEnjoyCL(idUnidad: number, idIdioma: number, anio: number, mes: number, idCategoria: number) {
        // tslint:disable-next-line: max-line-length
        return this.http.get(`${environment.path}${environment.service.promocionesEnjoyCL.endpoint}?idIdioma=${idIdioma}&idUnidad=${idUnidad}&anio=${anio}&mes=${mes}&idCategoria=${idCategoria}`);
    }

    detailPromocion(idPromocion, idIdioma) {
        // tslint:disable-next-line: max-line-length
        return this.http.get(`${environment.path}${environment.service.detailPromocion.endpoint}?idPromocion=${idPromocion}&idIdioma=${idIdioma}`);
    }

    verMasPromociones(idUnidad: number, idIdioma: number, idPromocion: number) {
        // tslint:disable-next-line: max-line-length
        return this.http.get(`${environment.path}${environment.service.verMasPromociones.endpoint}?idUnidad=${idUnidad}&idIdioma=${idIdioma}&idPromocion=${idPromocion}`);
    }

    casinoPromociones(idUnidad: number, idIdioma: number) {
        // tslint:disable-next-line: max-line-length
        return this.http.get(`${environment.path}${environment.service.casinoPromociones.endpoint}?idUnidad=${idUnidad}&idIdioma=${idIdioma}`);
    }

    contenidoDetalleServicioSpaUnidad(idUnidad: number, idTipoServicio: number, idIdioma: number) {
        // tslint:disable-next-line: max-line-length
        return this.http.get(`${environment.path}${environment.service.contenidoDetalleServicioSpaUnidad.endpoint}?idUnidad=${idUnidad}&idTipoServicio=${idTipoServicio}&idIdioma=${idIdioma}`);
    }
    contenidoDetalleSalon(idSalon: any, idIdioma: any) {
        // tslint:disable-next-line: max-line-length
        return this.http.get(`${environment.path}${environment.service.contenidoDetalleSalon.endpoint}?idSalon=${idSalon}&idIdioma=${idIdioma}`);

    }
    getImageInstagram(userId: any, token: any, callback: any) {
        // tslint:disable-next-line: max-line-length
        return this.http.jsonp(`https://api.instagram.com/v1/users/${userId}/media/recent?access_token=${token}&callback=JSON_CALLBACK`, callback);

    }
}
